<template>
  <div class="itinerary mb-3" :class="{ active: visible }">
    <div class="itinerarySummary">
      <div class="itinerarySummary__times">
        <div class="itinerarySummary__time align-self-start itinerarySummary__time--start">
                <span>
                    {{ timeStart }}
                    <small>{{ dateStart }}</small>
                </span>
        </div>
        <div class="itinerarySummary__number  align-self-start mt-2">
          {{ duration }}
          <div class="trip-breaks">
            <template v-for="n in tripBreaks + 1">
              <div></div>
            </template>
          </div>
          <small>{{ trainNumber }}<br v-if="change">{{ change }}</small>
        </div>
        <div class="itinerarySummary__time align-self-start itinerarySummary__time--end">
                <span>
                    {{ timeEnd }}
                    <small>{{ dateEnd }}</small>
                </span>
        </div>
      </div>
      <div class="itinerarySummary__button">
        <slot name="buy-button-slot">def</slot>
      </div>
    </div>
    <slot name="warning"></slot>
    <div v-if="details">
      <button class="itineraryMore itineraryMore--hide mx-auto" aria-expanded="true" @click="() => hide()"  v-if="visible" >zwiń szczegóły</button>
      <button class="itineraryMore mx-auto" aria-expanded="false" @click="() => show()" v-else>rozwiń szczegóły</button>

      <ul class="itineraryTimeline" v-show="visible">
        <slot name="timeline">
        <li class="itineraryTimeline__item itineraryTimeline__item--start">
                <span>
                    6:48
                    <small>3 lut</small>
                </span>
          Warszawa Centralna
          <small>peron III, tor 4</small>
        </li>
        <li class="itineraryTimeline__item itineraryTimeline__item--services">
          <div class="itineraryTimeline__icons">
            <img src="/images/itinerary/ico0.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico1.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico2.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico3.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico4.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico5.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico6.png" alt="" class="img-fluid">
            <img src="/images/itinerary/ico7.png" alt="" class="img-fluid">
          </div>
          <button class="extra-details-btn hidden focus" @click="() => hideExtraDetails()" v-if="extraDetailsVisible" aria-expanded="true" aria-label="zwiń szczegóły">
            <i class="bi bi-dash-circle-fill focus" ></i>
          </button>

          <button class="extra-details-btn hidden focus" @click="() => showExtraDetails()" v-if="!extraDetailsVisible" aria-expanded="false" aria-label="rozwiń szczegóły">
            <i class="bi bi-plus-circle-fill"></i>
          </button>
        </li>
        <template v-if="extraDetailsVisible">
          <li class="itineraryTimeline__item itineraryTimeline__item--station">
                <span>
                    <small>12:04</small>
                </span>
            <small>Warszawa Wschodnia</small>
          </li>
          <li class="itineraryTimeline__item itineraryTimeline__item--station">
                <span>
                    <small>12:04</small>
                </span>
            <small>Warszawa Wschodnia</small>
          </li>
          <li class="itineraryTimeline__item itineraryTimeline__item--station">
                <span>
                    <small>12:04</small>
                </span>
            <small>Warszawa Wschodnia</small>
          </li>
        </template>
        <li class="itineraryTimeline__item itineraryTimeline__item--change-start">
                <span>
                    6:48
                    <small>3 lut</small>
                </span>
          Warszawa Centralna
          <small>peron III, tor 4</small>
        </li>
        <li class="itineraryTimeline__item itineraryTimeline__item--change">
                <span>
                    <img src="/images/pin-change.svg" alt="">
                </span>
          <small>czas oczekiwania na stacji Koluszki wynosi 15 min.</small>
        </li>
        <li class="itineraryTimeline__item itineraryTimeline__item--change-end">
                <span>
                    6:48
                    <small>3 lut</small>
                </span>
          Warszawa Centralna
          <small>peron III, tor 4</small>
        </li>
        <li class="itineraryTimeline__item itineraryTimeline__item--end">
                <span>
                    16:48
                    <small>3 lut</small>
                </span>
          Kielce
        </li>
       </slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Itinerary',
  props: {
    dateStart: {
      type: String,
      required: true
    },
    timeStart: {
      type: String,
      required: true
    },
    dateEnd: {
      type: String,
      required: true
    },
    timeEnd: {
      type: String,
      required: true
    },
    trainNumber: {
      type: String,
      required: true
    },
    duration: {
      type: String,
      required: true
    },
    change: {
      type: String
    },
    buyButton: {
      type: Boolean
    },
    details: {
      type: String
    },
    tripBreaks: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      extraDetailsVisible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    showExtraDetails() {
      this.extraDetailsVisible = true;
    },
    hideExtraDetails(){
      this.extraDetailsVisible = false;
    }
  }
}
</script>